import type { Extensions } from '@tiptap/core'
import type { EditorAdapter } from './adapter'
import { IssueRef } from '../extensions/issue-reference'
import { MacroSuggestion, RedmineMacroBlock, RedmineMacroInline } from '../extensions/redmine-macro'
import { ResourceRef } from '../extensions/resource-ref'
import { UserMention } from '../extensions/user-mention'

export class DocumentAdapter implements EditorAdapter {
  readonly context = 'document' as const
  readonly textareaSelector = '#document_description'
  readonly attachmentsContainerSelector = '.attachments_fields'

  constructor(private readonly meta: HTMLElement) { }

  get previewUrl(): string | undefined {
    return this.meta.dataset.previewUrl || undefined
  }

  get uploadPath(): string {
    return document.querySelector<HTMLInputElement>('input.filedrop')
      ?.dataset
      .uploadPath ?? '/uploads.js'
  }

  get userMentionUrl(): string | null {
    return this.meta.dataset.userMentionUrl || null
  }

  get issueSuggestionUrl(): string | null {
    return null
  }

  get wikiPageSuggestionUrl(): string | null {
    return null
  }

  get extensions(): Extensions {
    const exts: Extensions = [IssueRef, RedmineMacroInline, RedmineMacroBlock, ResourceRef, MacroSuggestion]
    if (this.userMentionUrl)
      exts.push(UserMention.configure({ url: this.userMentionUrl }))
    return exts
  }
}
